exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-blog-jsx": () => import("./../../../src/pages/blog.jsx" /* webpackChunkName: "component---src-pages-blog-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-prywatnosc-jsx": () => import("./../../../src/pages/prywatnosc.jsx" /* webpackChunkName: "component---src-pages-prywatnosc-jsx" */),
  "component---src-pages-uslugi-jsx": () => import("./../../../src/pages/uslugi.jsx" /* webpackChunkName: "component---src-pages-uslugi-jsx" */)
}

